import moment from "moment";
import { Cell } from "react-table";
import { UserGuideModel, UserGuideType, UserGuideTypeMap } from "src/api/guide/guide-types";
import { BaseTooltip } from "src/components";
import DetailLink from "src/components/DetailLink";
import PagePath from "src/pagePath.json";
import { ViewYmdFormat } from "src/utils";
import { userGuideTargetText } from "../../guide-types";

/*
  이용안내 목록
*/
const guideListColumns = [
  {
    Header: "이용안내 ID",
    accessor: "id",
    width: 120,
    Cell: (props: Cell<UserGuideModel>) => {
      const detailPath = `${PagePath.guide.detail.replace(":id", `${props.value}`)}`;
      return (
        <div>
          <DetailLink className="text-underline" to={`${detailPath}`}>
            {props.value || "-"}
          </DetailLink>
        </div>
      );
    },
  },
  {
    Header: "프로바이더",
    accessor: "providerName",
    width: 240,
    Cell: (props: Cell<UserGuideModel>) => {
      return <BaseTooltip contents={props.value} className="w-100 text-left"></BaseTooltip>;
    },
  },
  {
    Header: "유형",
    accessor: "type",
    width: 160,
    align: "center",
    Cell: (props: Cell<UserGuideModel>) => <span>{UserGuideTypeMap[props.value as UserGuideType]}</span>,
  },
  {
    Header: "적용대상",
    accessor: "targetsList",
    width: 160,
    align: "center",
    Cell: (props: Cell<UserGuideModel>) => <span>{userGuideTargetText(props.value || [])}</span>,
  },
  {
    // 상세 페이지 이동 제거 (진입은 이용안내 ID 컬럼으로 일원화)
    Header: "항목명",
    accessor: "subject",
    width: 480,
    Cell: (props: Cell<UserGuideModel>) => {
      return (
        <div className="w-100 flex-start">
          <BaseTooltip contents={props.value || "-"} />
        </div>
      );
    },
  },
  {
    Header: "최종 수정일시",
    accessor: "modifiedDate",
    width: 160,
    align: "center",
    // ISO 8601 표준(YYYY-MM-DD HH:mm:ss), 당일 여부와 관계없이 날짜+시간 항상 노출 (호버 제거)
    Cell: ({ value }: Cell<UserGuideModel>) => <span>{value ? moment(value).format(ViewYmdFormat.FULL) : "-"}</span>,
  },
];

export default guideListColumns;
